import { useState, useEffect } from 'react';
import { desktopBreakpoint } from '~/variables/breakpoints';
import useDebouncedValue from './useDebouncedValue';

const useWindowSize = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < desktopBreakpoint);
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const debouncedIsMobile = useDebouncedValue(isMobile, 200);
  const debouncedInnerHeight = useDebouncedValue(innerHeight, 200);
  const debouncedInnerWidth = useDebouncedValue(innerWidth, 200);
  useEffect(() => {
    const setWindowParams = () => {
      const newInnerHeight = window.innerHeight;
      const newInnerWidth = window.innerWidth;
      const newIsMobile = newInnerWidth < desktopBreakpoint;
      if (
        newIsMobile !== isMobile ||
        newInnerHeight !== innerHeight ||
        newInnerWidth !== innerWidth
      ) {
        setIsMobile(newIsMobile);
        setInnerHeight(newInnerHeight);
        setInnerWidth(newInnerWidth);
      }
    };
    window.addEventListener('resize', setWindowParams);
    setWindowParams();
    return () => window.removeEventListener('resize', setWindowParams);
  }, [innerHeight, innerWidth, isMobile]);
  return {
    isMobile: debouncedIsMobile,
    innerHeight: debouncedInnerHeight,
    innerWidth: debouncedInnerWidth,
  };
};

export default useWindowSize;
